import { defineMessages } from 'react-intl';

import ResponsiveContentBlockEdit from './manage/Blocks/ResponsiveContent/Edit';
import ResponsiveContentBlockLayout from './manage/Blocks/ResponsiveContent/LayoutSchema';
import ResponsiveContentBlockView from './manage/Blocks/ResponsiveContent/View';

import codeSVG from './icons/responsive-content.svg';

defineMessages({
  responsiveContent: {
    id: 'Responsive content',
    defaultMessage: 'Responsive content',
  },
  responsiveContentSettings: {
    id: 'Responsive content settings',
    defaultMessage: 'Responsive content settings',
  },
});

const applyConfig = (config) => {
  const choices = Object.keys(config.blocks.blocksConfig)
    .map((key) => {
      if (config.blocks.blocksConfig[key]?.restricted) {
        return false;
      } else {
        const title = config.blocks.blocksConfig[key]?.title || key;
        return [key, title];
      }
    })
    .filter((val) => !!val);

  choices.push(['group', 'Group']);

  const layoutSchema = ResponsiveContentBlockLayout({});

  const schema = {
    ...layoutSchema,
    properties: {
      ...layoutSchema.properties,
      allowedBlocks: {
        ...layoutSchema.properties.allowedBlocks,
        items: {
          choices: choices,
        },
      },
    },
  };
  config.blocks.blocksConfig.responsiveContent = {
    id: 'responsiveContent',
    title: 'Responsive content',
    icon: codeSVG,
    group: 'layout',
    view: ResponsiveContentBlockView,
    edit: ResponsiveContentBlockEdit,
    schema: schema,
    restricted: false,
    mostUsed: false,
    blockHasOwnFocusManagement: true,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };

  return config;
};

export default applyConfig;
